import { atom } from '@synergyeffect/react-atom';
import {withMergedClassName} from 'util/react';

// Flat: no shadows on buttons (docs/DESIGN_SYSTEM.md 7.1).
const BASE = 'inline-flex items-center justify-center gap-2 leading-5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60';

const CLASS_NAME_PRIMARY = `${BASE} min-h-10 rounded-xl border border-transparent bg-blue-600 font-semibold text-white hover:bg-blue-700`;
const CLASS_NAME_SECONDARY = `${BASE} min-h-10 rounded-xl border border-slate-200 bg-white font-medium text-slate-700 hover:bg-slate-50`;
const CLASS_NAME_DANGER = `${BASE} min-h-10 rounded-xl border border-transparent bg-rose-600 font-semibold text-white hover:bg-rose-700 focus-visible:ring-rose-500/40`;
const CLASS_NAME_TEXT = `${BASE} min-h-9 rounded-lg font-medium text-blue-600 hover:text-blue-700 hover:bg-blue-50`;

const CLASS_NAME_COMPACT_PRIMARY = `${BASE} rounded-lg border border-transparent bg-blue-600 font-medium text-white hover:bg-blue-700`;
const CLASS_NAME_COMPACT_SECONDARY = `${BASE} rounded-lg border border-slate-200 bg-white font-medium text-slate-700 hover:bg-slate-50`;

const TailwindUiPrimary = ({Tag = 'button', ...props}) => (
  <Tag className={`${CLASS_NAME_PRIMARY} px-4 py-2.5 text-sm`} {...props} />
);

const TailwindUiSecondary = ({Tag = 'button', ...props}) => (
  <Tag className={`${CLASS_NAME_SECONDARY} px-4 py-2.5 text-sm`} {...props} />
);

const TailwindUiDanger = ({Tag = 'button', ...props}) => (
  <Tag className={`${CLASS_NAME_DANGER} px-4 py-2.5 text-sm`} {...props} />
);

const Button = atom(<TailwindUiPrimary className={`${CLASS_NAME_PRIMARY} px-4 py-2.5 text-sm`}/>);

Button.Sm = withMergedClassName(`${CLASS_NAME_PRIMARY} px-4 py-2.5 text-sm`, TailwindUiPrimary);
Button.Xs = withMergedClassName(`${CLASS_NAME_COMPACT_SECONDARY} px-3 py-2 text-xs`, TailwindUiSecondary);
Button.Xxs = withMergedClassName(`${CLASS_NAME_COMPACT_PRIMARY} px-2.5 py-1.5 text-xs`, TailwindUiPrimary);

Button.Nd = withMergedClassName(`${CLASS_NAME_SECONDARY} px-4 py-2.5 text-sm`, TailwindUiSecondary);
Button.NoBg = withMergedClassName(`${CLASS_NAME_TEXT} px-3 py-2 text-sm`, TailwindUiPrimary);

Button.Primary = withMergedClassName(`${CLASS_NAME_PRIMARY} px-4 py-2.5 text-sm`, TailwindUiPrimary);
Button.Secondary = withMergedClassName(`${CLASS_NAME_SECONDARY} px-4 py-2.5 text-sm`, TailwindUiSecondary);
Button.Danger = withMergedClassName(`${CLASS_NAME_DANGER} px-4 py-2.5 text-sm`, TailwindUiDanger);

Button.Pxl = withMergedClassName(`${CLASS_NAME_PRIMARY} px-6 py-3 text-base`, TailwindUiPrimary);
Button.Sxl = withMergedClassName(`${CLASS_NAME_SECONDARY} px-6 py-3 text-base`, TailwindUiSecondary);
Button.Dxl = withMergedClassName(`${CLASS_NAME_DANGER} px-6 py-3 text-base`, TailwindUiDanger);


export default Button;
